import { DowngradeModalService } from '@go-modules/services/downgrade-modal/downgrade-modal.service';
import { noop } from 'angular';
import { CloseTypeEnum } from './modal.factory';
import { SelectedService } from 'go-modules/services/selected/selected.service';
import { NgxTaskService } from '@go-modules/services/task/task.service';

export class PostDiscardSessionModalController {
	public $close: (result?: any) => boolean;

	/* @ngInject */
	constructor (
		private ngxDowngradeModalService: DowngradeModalService,
		private $translate: ng.translate.ITranslateService,
		private selectedService: SelectedService,
		private taskService: NgxTaskService
	) {}

	public hasSubmitTask (): boolean {
		const activity = this.selectedService.selected.activity;
		return this.taskService.hasSubmitTask(activity.activity_id);
	}

	public confirmRestartSession () {
		return this.ngxDowngradeModalService.openConfirmDialog({
			title: this.$translate.instant('modal-confirm-restart-session_title'),
			message: this.$translate.instant('modal-confirm-restart-session_message'),
			confirmText: this.$translate.instant('modal-confirm-restart-session_title')
		}).then(() => {
			return this.$close({ type: CloseTypeEnum.RESTART });
		}).catch(noop);
	}

	public confirmDiscardSession () {
		return this.ngxDowngradeModalService.openConfirmDialog({
			title: this.$translate.instant('modal-confirm-session-discard_confirm-discard'),
			message: this.$translate.instant('modal-confirm-session-discard_sure-discard'),
			confirmText: this.$translate.instant('common_delete')
		}).then(() => {
			return this.$close({ type: CloseTypeEnum.DISCARD });
		}).catch(noop);
	}
}
